import React, { useEffect, useState } from "react";
import { FaBuilding } from "react-icons/fa";
import Layout from "../../components/Layout";
import { apiCRMv3 } from "../../services/api";
import Swal from "sweetalert2";
import * as moment from "moment-timezone";
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
	Legend,
	LineChart,
	Line,
} from "recharts";

export default function WebsiteAccessCount() {
	const [traffic, setTraffic] = useState([]);
	const [branches, setBranches] = useState([]);
	const [sellerClicksTotal, setSellerClicksTotal] = useState([]);
	const [loaded, setLoaded] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [branchToShow, setBranchToShow] = useState([]);
	const [dtBegin, setDtBegin] = useState(
		moment().startOf("day").format("YYYY-MM-DD"),
	);
	const [dtEnd, setDtEnd] = useState(
		moment().endOf("day").format("YYYY-MM-DD"),
	);
	const [showClicksGraph, setShowClicksGraph] = useState(false);
	const [branchesByRegional, setBranchesByRegional] = useState({});
	const [selectedRegional, setSelectedRegional] = useState(null);
	const [graphView, setGraphView] = useState("accesses"); // "accesses" | "branchClicks" | "sellerClicks"
	const [totalFiltered, setTotalFiltered] = useState({
		totalAcessos: 0,
		totalCliques: 0,
	});
	const [accessByHour, setAccessByHour] = useState([]);
	const [accessByBranch, setAccessByBranch] = useState([]);
	const [clicksByBranch, setClicksByBranch] = useState([]);
	const [clicksBySeller, setClicksBySeller] = useState([]);
	const [accessByMonth, setAccessByMonth] = useState([]);

	const regional = {
		R01: ["10022", "10045", "10046", "10070", "10079", "10082", "10184", "10186", "10187", "10190", "10191", "10192", "10196", "10250", "10271", "10285", "10311", "10320", "10321", "10322", "10325", "10377", "10425"],
		R02: ["10027", "10034", "10036", "10044", "10062", "10078", "10116", "10141", "10261", "10272", "10281", "10290", "10291", "10305", "10306", "10313", "10323", "10336", "10347", "10350", "10355", "10367", "10401", "10402", "10417", "10426"],
		R03:["10002", "10003", "10004", "10024", "10033", "10040", "10048", "10071", "10073", "10076", "10098", "10128", "10154", "10172", "10234", "10270", "10282", "10284", "10289", "10299", "10300", "10309", "10338", "10342", "10351", "10400", "10404", "10405"],
		R04: ["10018", "10043", "10064", "10084", "10089", "10093", "10118", "10147", "10149", "10159", "10171", "10226", "10248", "10258", "10263", "10304", "10310", "10312", "10316", "10324", "10335", "10337", "10340", "10341", "10418", "10419"],
		R05: ["10005", "10006", "10007", "10008", "10016", "10020", "10030", "10032", "10039", "10041", "10047", "10049", "10051", "10081", "10101", "10112", "10132", "10134", "10197", "10247", "10255", "10262", "10287", "10301", "10327", "10345", "10376", "10407", "10409", "10431"],
		R06: ["10013", "10015", "10023", "10029", "10061", "10100", "10111", "10123", "10124", "10129", "10130", "10135", "10158", "10170", "10202", "10237", "10280", "10302", "10314", "10315", "10328", "10329", "10343", "10344", "10392", "10403", "10410", "10424", "10430", "10432"],
		R07: ["10055", "10075", "10102", "10103", "10127", "10139", "10140", "10157", "10200", "10218", "10219", "10239", "10240", "10259", "10278", "10297", "10317", "10326", "10332", "10358", "10374", "10387", "10388", "10389", "10422"],
		R08: ["10021", "10026", "10037", "10053", "10057", "10065", "10066", "10083", "10090", "10113", "10117", "10120", "10199", "10205", "10206", "10207", "10236", "10238", "10256", "10279", "10295", "10296", "10334", "10339", "10381", "10393"],
		R09: ["10072", "10080", "10114", "10136", "10137", "10145", "10153", "10160", "10165", "10166", "10167", "10169", "10178", "10179", "10193", "10194", "10195", "10211", "10215", "10233", "10235", "10292", "10318", "10353", "10359", "10368", "10382", "10383", "10386", "10411"],
		R10: ["10229", "10230", "10231", "10232", "10241", "10242", "10243", "10246", "10249", "10253", "10254", "10275", "10276", "10346", "10357", "10369", "10370", "10371", "10372", "10373", "10378", "10380", "10396", "10397", "10398", "10420", "10421", "10428", "10429"],
		R11: ["10009", "10010", "10011", "10012", "10014", "10017", "10019", "10052", "10056", "10087", "10088", "10095", "10107", "10119", "10126", "10131", "10133", "10142", "10144", "10183", "10185", "10214", "10224", "10286", "10288", "10293", "10394", "10395", "10412"],
		R12: ["240001", "240003", "240004", "240005", "240006", "240007", "240009", "240010", "240011", "240012", "240014", "240015", "240016", "240017", "240018", "240019", "240020", "240022", "240023", "240024", "240029", "240035", "240036", "240039", "240048"],
		R13: ["10035", "10054", "10059", "10060", "10074", "10086", "10091", "10092", "10094", "10097", "10104", "10110", "10148", "10151", "10181", "10209", "10220", "10221", "10257", "10260", "10348", "10384", "10385", "10390", "10416"],
		R14: ["10399", "140002", "140003", "140004", "140005", "140006", "140007", "140008", "140009"],
		R15: ["10264", "10273", "10274", "10277", "10319", "10349", "240025", "240026", "240027", "240028", "240030", "240031", "240032", "240033", "240034", "240038", "240040", "240041", "240042", "240043", "240044", "240045", "240046"],
	};

	useEffect(() => {
		const load = async () => {
			const firstDay = moment()
				.startOf("day")
				.format("YYYY-MM-DD HH:mm:ss");
			const now = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
			await loadBranches();
			await loadItems(firstDay, now);
			await loadSellerClicks(firstDay, now);
			await loadByHour(firstDay, now);
			await loadByMounth();
		};
		load();
	}, []);

	const loadItems = async (start, end) => {
		setLoaded(false);
		let allTraffic = [];
		const response = await apiCRMv3.get(`/traffic/list-traffic`, {
			params: { start, end },
		});
		const trafficLog = response.data?.data?.trafficLog || [];
		const accessByBranchLog = response.data?.data?.accessByBranch || [];
		allTraffic = allTraffic.concat(trafficLog);
		setTraffic(allTraffic);
		setAccessByBranch(accessByBranchLog);
		setLoaded(true);
	};

	const total = traffic.length;

	const loadBranches = async () => {
		setLoaded(false);
		const response = await apiCRMv3.get(`/branch`);
		setBranches(response.data.data || []);
		setLoaded(true);
	};

	const loadSellerClicks = async (start, end) => {
		const response = await apiCRMv3.get(`/traffic/seller-clicks`, {
			params: { start, end },
		});
		const sellerClicks = response.data?.data?.clicksBySeller || [];
		const clicksByBranchLog = response.data?.data?.clicksByBranch || [];
		const total = response.data?.data?.totalClicks || 0;
		setClicksBySeller(sellerClicks);
		setClicksByBranch(clicksByBranchLog);
		setSellerClicksTotal(total);
	};

	const loadByHour = async (start, end) => {
		try {
			const response = await apiCRMv3.get(
				`/traffic/access-clicks-by-hour`,
				{
					params: { start, end },
				},
			);
			let accessByHour = response.data?.data?.data?.hours || [];
			setAccessByHour(accessByHour);
		} catch (error) {
			console.error("Erro ao carregar acessos por hora:", error);
		}
	};

	const loadByMounth = async () => {
		try {
			const response = await apiCRMv3.get(
				`/traffic/access-clicks-by-month`,
			);
			const accessByMonth = response.data?.data?.data?.days || [];
			setAccessByMonth(accessByMonth);
		} catch (error) {
			console.error("Erro ao carregar acessos por mes:", error);
		}
	};

	const sortedBranches = branches
		.map((branch) => ({
			...branch,
			accesses: accessByBranch[branch.longCode] ?? 0,
			cityName: branch.city?.name ?? "",
			stateAbbr: branch.city?.state?.abbreviation ?? "",
		}))
		.filter((branch) => branch.accesses > 0)
		.sort((a, b) => b.accesses - a.accesses);

	const topTenBranches = sortedBranches.slice(0, 10).map((branch) => ({
		...branch,
		label: `${branch.shortCode} - ${branch.city?.name}-${branch.city?.state.abbreviation}`,
	}));

	const topTenBranchesClicks = Object.entries(clicksByBranch)
		.map(([longCode, clicksArray]) => ({
			longCode,
			clicks: clicksArray.length,
		}))
		.sort((a, b) => b.clicks - a.clicks)
		.slice(0, 10);

	const topTenSellersClicks = Object.entries(clicksBySeller)
		.map(([seller, data]) => ({
			seller,
			clicks: data.clicks,
			label: `${seller} (${data.branch})`
		}))
		.filter(s => s.seller !== "Desconhecido") // ✅ opcional, remove sem nome
		.sort((a, b) => b.clicks - a.clicks)
		.slice(0, 10);

	function showClicks(branchCode) {
		const clicks = clicksByBranch[branchCode] || [];
		if (clicks.length === 0) {
			Swal.fire("Info", "Nenhum clique registrado nesta filial.", "info");
			return;
		}

		// Agrupa cliques por vendedor
		const clicksCount = clicks.reduce((acc, c) => {
			const seller = c.sellerName || "Desconhecido";
			acc[seller] = (acc[seller] || 0) + 1;
			return acc;
		}, {});

		// Calcula total de cliques da filial
		const totalClicks = Object.values(clicksCount).reduce(
			(sum, count) => sum + count,
			0,
		);

		// Constrói o HTML com quantidade de cliques por vendedor
		const html = Object.entries(clicksCount)
			.map(
				([seller, count]) =>
					`<div><strong>Vendedor:</strong> ${seller} - ${count}x</div>`,
			)
			.join("");

		Swal.fire({
			title: `Cliques - Filial ${branchCode} (Total: ${totalClicks} cliques)`,
			html,
			width: 600,
			showCloseButton: true,
		});
	}

	async function getReportAccess() {
		try {
			const { value: formValues } = await Swal.fire({
				title: "Selecionar período",
				html:
					'<input type="date" id="swal-date-begin" className="swal2-input" placeholder="Data início">' +
					'<input type="date" id="swal-date-end" className="swal2-input" placeholder="Data fim">',
				focusConfirm: false,
				showCancelButton: true,
				preConfirm: () => {
					let dateBegin =
						document.getElementById("swal-date-begin").value;
					let dateEnd =
						document.getElementById("swal-date-end").value;
					if (!dateBegin || !dateEnd) {
						Swal.showValidationMessage(
							`Por favor, preencha ambas as datas`,
						);
						return null;
					}
					dateBegin = moment
						.tz("America/Sao_Paulo")
						.startOf("day")
						.toDate()
						.toISOString();
					dateEnd = moment
						.tz("America/Sao_Paulo")
						.endOf("day")
						.toDate()
						.toISOString();
					return { dateBegin, dateEnd };
				},
			});

			if (!formValues) return;

			setLoaded(false);

			const response = await apiCRMv3.get(`/traffic/export`, {
				params: {
					start: formValues.dateBegin,
					end: formValues.dateEnd,
				},
				responseType: "blob",
			});

			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute(
				"download",
				`Relatorio_Acessos_${formValues.dateBegin}_a_${formValues.dateEnd}.xlsx`,
			); // nome do arquivo
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);

			Swal.fire(
				"Sucesso!",
				"O relatório foi baixado com sucesso!",
				"success",
			);

			setLoaded(true);
		} catch (err) {
			console.log(err);
			Swal.fire(
				"Erro!",
				"Problemas ao gerar o relatório. Por favor contate o suporte!",
				"error",
			);
			setLoaded(true);
		}
	}

	async function getReportSellerClicks() {
		try {
			const { value: formValues } = await Swal.fire({
				title: "Selecionar período",
				html:
					'<input type="date" id="swal-date-begin" className="swal2-input" placeholder="Data início">' +
					'<input type="date" id="swal-date-end" className="swal2-input" placeholder="Data fim">',
				focusConfirm: false,
				showCancelButton: true,
				preConfirm: () => {
					let dateBegin =
						document.getElementById("swal-date-begin").value;
					let dateEnd =
						document.getElementById("swal-date-end").value;
					if (!dateBegin || !dateEnd) {
						Swal.showValidationMessage(
							`Por favor, preencha ambas as datas`,
						);
						return null;
					}
					dateBegin = moment
						.tz("America/Sao_Paulo")
						.startOf("day")
						.toDate()
						.toISOString();
					dateEnd = moment
						.tz("America/Sao_Paulo")
						.endOf("day")
						.toDate()
						.toISOString();

					return { dateBegin, dateEnd };
				},
			});

			if (!formValues) return;

			setLoaded(false);

			const response = await apiCRMv3.get(
				`/traffic/seller-clicks/export`,
				{
					params: {
						start: formValues.dateBegin,
						end: formValues.dateEnd,
					},
					responseType: "blob",
				},
			);

			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute(
				"download",
				`Relatorio_Clique_Vendedores_${formValues.dateBegin}_a_${formValues.dateEnd}.xlsx`,
			); // nome do arquivo
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);

			Swal.fire(
				"Sucesso!",
				"O relatório foi baixado com sucesso!",
				"success",
			);

			setLoaded(true);
		} catch (err) {
			console.log(err);
			Swal.fire(
				"Erro!",
				"Problemas ao gerar o relatório. Por favor contate o suporte!",
				"error",
			);
			setLoaded(true);
		}
	}

	const handleSearch = async () => {
		setLoaded(false);
		const start = moment(dtBegin)
			.startOf("day")
			.format("YYYY-MM-DD HH:mm:ss");
		const end = moment(dtEnd).endOf("day").format("YYYY-MM-DD HH:mm:ss");

		console.log(start, end);
		await Promise.all([
			loadItems(start, end),
			loadSellerClicks(start, end),
			loadByHour(start, end),
		]);
		setLoaded(true);
	};

	function handleSearchBar() {
		setLoaded(false);

		const originalBranches = sortedBranches;

		if (!searchText.trim()) {
			setBranchToShow(originalBranches);
			setTotalFiltered({ totalAcessos: 0, totalCliques: 0 });
			setLoaded(true);
			return;
		}

		const search = searchText.toLowerCase();

		const filteredBranches = originalBranches.filter((branch) => {
			const longCodeMatch = branch.longCode
				.toLowerCase()
				.includes(search);
			const cityMatch = branch.cityName.toLowerCase().includes(search);
			const stateMatch = branch.stateAbbr.toLowerCase() === search; // busca exata pelo estado

			// se o input for sigla de estado, só retorna pelo estado
			if (search.length === 2) {
				return stateMatch;
			}

			// caso contrário, busca por longCode ou cidade
			return longCodeMatch || cityMatch;
		});

		const totais = filteredBranches.reduce(
			(acc, branch) => {
				const accessFiltered = traffic.filter(
					(t) => t.branchLongCode === branch.longCode,
				).length;

				// agora usa clicksByBranch (já agrupado por longCode)
				const clicFiltered =
					clicksByBranch[branch.longCode]?.length || 0;

				acc.totalAccessFiltered += accessFiltered;
				acc.totalClicksFitered += clicFiltered;
				return acc;
			},
			{ totalAccessFiltered: 0, totalClicksFitered: 0 },
		);
		setBranchToShow(filteredBranches);
		setTotalFiltered(totais);
		setLoaded(true);
	}

	const separateByRegional = () => {
		const result = {};

		Object.entries(regional).forEach(([regionalName, codes]) => {
			result[regionalName] = branches
				.filter((branch) => codes.includes(branch.longCode))
				.map((branch) => ({
					...branch,
					cityName: branch.city?.name ?? "",
					stateAbbr: branch.city?.state?.abbreviation ?? "",
				}));
		});

		setBranchesByRegional(result);
		setSelectedRegional(null); // limpa a seleção
	};

	const handleGraphViewChange = async (view) => {
		setGraphView(view);

		if (view === "accessbyMounth") {
			await loadByMounth();
		}
	};

	const chartData =
		graphView === "accesses" && Array.isArray(topTenBranches)
			? topTenBranches.map((branch) => ({
				...branch,
				label: `${branch.shortCode}-${branch.city?.name ?? ""}-${branch.city?.state?.abbreviation ?? ""}`,
			}))
			: graphView === "branchClicks" &&
				Array.isArray(topTenBranchesClicks)
				? topTenBranchesClicks.map((branch) => ({
					longCode: branch.longCode,
					clicks: branch.clicks,
					label: `Filial ${branch.longCode}`,
				}))
				: graphView === "accessbyMonth" && Array.isArray(accessByMonth)
					? accessByMonth.map((data) => ({
						day: data.days,
						accesses: data.accesses,
						clicks: data.clicks,
						label: `${data.days}`, // só o dia para o eixo X
					}))
					: Array.isArray(topTenSellersClicks)
						? topTenSellersClicks.map((seller) => ({
							...seller,
							label: `${seller.label}`,
						}))
						: [];
	return (
		<Layout
			pageTitle="Acessos Fale Com Vendedor"
			enableSearchBar={true}
			searchTerm={searchText}
			searchOnChange={(e) => setSearchText(e.target.value)}
			handleSearch={handleSearchBar}
			searchPlaceholder="Estado, Cidade Código"
		>
			<div>
				<form>
					<div className="col-xs-2">
						<label htmlFor="dtBegin-filter">Data Inicial</label>
						<input
							className="form-control"
							type="date"
							id="dtBegin-filter"
							value={dtBegin}
							onChange={(e) => setDtBegin(e.target.value)}
						/>
					</div>

					<div className="col-xs-2">
						<label htmlFor="dtEnd-filter">Data Final</label>
						<input
							className="form-control"
							type="date"
							id="dtEnd-filter"
							value={dtEnd}
							onChange={(e) => setDtEnd(e.target.value)}
						/>
					</div>

					<div
						className="col-xs-2"
						style={{
							transform: "translateY(70%)",
						}}
					>
						<button
							className="btn btn-primary btn-large"
							type="button"
							onClick={handleSearch}
						>
							Buscar
						</button>
						&nbsp;&nbsp;
						<button
							className="btn btn-warning btn-large"
							type="button"
							onClick={() => window.location.reload()}
						>
							Limpar
						</button>
					</div>
				</form>
			</div>
			<br></br> <br></br> <br></br>
			{!loaded && (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100vw",
						height: "100vh",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						background: "rgba(255, 255, 255, 0.9)",
						zIndex: 9999,
					}}
				>
					<div className="icon">
						<div className="sk-wave">
							<div className="sk-rect sk-rect1"></div>
							<div className="sk-rect sk-rect2"></div>
							<div className="sk-rect sk-rect3"></div>
							<div className="sk-rect sk-rect4"></div>
							<div className="sk-rect sk-rect5"></div>
						</div>
					</div>
					<div className="title">Carregando</div>
				</div>
			)}
			<div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
				<h2>Total de Acessos: {total}</h2>
				<h2>Total de Cliques: {sellerClicksTotal}</h2>
				{/* <div style={{ marginBottom: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <button className="btn btn-success btn-large"
                        type="button" onClick={(e) => {
                            getReportAccess();
                        }}>
                        Exportar Acessos
                    </button>

                    <button className="btn btn-primary btn-large"
                        type="button" onClick={(e) => {
                            getReportSellerClicks();
                        }}>
                        Exportar Cliques Vendedores
                    </button>
                </div> */}
				<div style={{ width: "100%", height: 400 }}>
					<ResponsiveContainer>
						<LineChart
							data={accessByHour}
							margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
						>
							<CartesianGrid strokeDasharray="3 3" />
							<XAxis dataKey="hour" />
							<YAxis />
							<Tooltip />
							<Legend />
							<Line
								type="monotone"
								dataKey="accesses"
								stroke="#095077"
								strokeWidth={3}
								name="Acessos"
							/>
							<Line
								type="monotone"
								dataKey="clicks"
								stroke="#28a745"
								strokeWidth={3}
								name="Cliques"
							/>
						</LineChart>
					</ResponsiveContainer>
				</div>

				{searchText.trim() === "" && !selectedRegional && (
					<>
						<div
							style={{ marginTop: "40px", marginBottom: "20px" }}
						>
							<button
								className="btn btn-secondary"
								onClick={() => setGraphView("accesses")}
							>
								Top 10 Filiais (Acessos)
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => setGraphView("branchClicks")}
								style={{ marginLeft: "10px" }}
							>
								Top 10 Filiais (Cliques em Vendedores)
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => setGraphView("sellerClicks")}
								style={{ marginLeft: "10px" }}
							>
								Top 10 Vendedores (Mais Clicados)
							</button>
							<button
								className="btn btn-secondary"
								onClick={() =>
									handleGraphViewChange("accessbyMonth")
								}
								style={{ marginLeft: "10px" }}
							>
								Dados Mensal
							</button>
						</div>
						<ResponsiveContainer width="100%" height={400}>
							<BarChart data={chartData}>
								<CartesianGrid strokeDasharray="3 3" />
								<XAxis
									dataKey={
										graphView === "accessbyMonth"
											? "day"
											: "label"
									}
									label={{
										value:
											graphView === "sellerClicks"
												? "Vendedor (Filial)"
												: graphView === "accessbyMonth"
													? "Dia"
													: "Filial",
										position: "insideBottom",
										offset: -5,
									}}
									interval={0}
									tickFormatter={(value) =>
										graphView === "sellerClicks"
											? value.split(" ")[0] // só primeiro nome
											: value
									}
								/>
								<YAxis />
								<Tooltip />
								<Legend />
								{graphView === "accessbyMonth" ? (
									<>
										<Bar
											dataKey="accesses"
											fill="#095077"
											name="Acessos"
										/>
										<Bar
											dataKey="clicks"
											fill="#28a745"
											name="Cliques"
										/>
									</>
								) : (
									<Bar
										dataKey={
											graphView === "sellerClicks"
												? "clicks"
												: graphView === "branchClicks"
													? "clicks"
													: "accesses"
										}
										fill="#095077"
										name={
											graphView === "sellerClicks"
												? "Cliques"
												: graphView === "branchClicks"
													? "Cliques"
													: "Acessos"
										}
										onClick={(data) => {
											if (graphView !== "sellerClicks") {
												showClicks(data.longCode);
											}
										}}
									/>
								)}
							</BarChart>
						</ResponsiveContainer>
					</>
				)}
				<div
					style={{
						marginBottom: "20px",
						display: "flex",
						justifyContent: "flex-end",
						gap: "10px",
					}}
				>
					<button
						className="btn btn-primary btn-large"
						type="button"
						onClick={separateByRegional}
					>
						Listar Por Regional
					</button>
					<button
						className="btn btn-warning btn-large"
						type="button"
						onClick={() => window.location.reload()}
					>
						Limpar
					</button>
				</div>
				{/* Lista de regionais */}
				{Object.keys(branchesByRegional).length > 0 && (
					<div style={{ marginTop: "20px" }}>
						<h3>Escolha uma regional:</h3>
						<div
							style={{
								display: "flex",
								gap: "10px",
								flexWrap: "wrap",
							}}
						>
							{Object.keys(branchesByRegional).map((reg) => (
								<button
									key={reg}
									className={`btn btn-secondary ${selectedRegional === reg ? "active" : ""}`}
									onClick={() => setSelectedRegional(reg)}
								>
									{reg}
								</button>
							))}
						</div>
					</div>
				)}
				<div
					style={{
						display: "flex",
						gap: "20px",
						flexWrap: "wrap",
						marginTop: "100px",
					}}
				>
					{(() => {
						const displayedBranches = selectedRegional
							? branchesByRegional[selectedRegional] // usa apenas a regional selecionada
							: searchText.trim() === ""
								? sortedBranches
								: branchToShow;

						// soma acessos e cliques das filiais filtradas
						const totalAccessFiltered = displayedBranches.reduce(
							(sum, { longCode }) =>
								sum + (accessByBranch[longCode] || 0),
							0,
						);

						const totalClicksFiltered = displayedBranches.reduce(
							(sum, { longCode }) =>
								sum + (clicksByBranch[longCode] || []).length,
							0,
						);

						return (
							<>
								{/* Totais filtrados */}
								{(selectedRegional ||
									searchText.trim() !== "") && (
										<div
											style={{
												marginBottom: "20px",
												padding: "15px",
												background: "#f8f9fa",
												borderRadius: "12px",
												boxShadow:
													"0 4px 8px rgba(0,0,0,0.05)",
											}}
										>
											<h3
												style={{
													margin: 0,
													marginBottom: "10px",
													color: "#095077",
												}}
											>
												Totais (filtrados)
											</h3>
											<p>
												<strong>Acessos:</strong>{" "}
												{totalAccessFiltered}
											</p>
											<p>
												<strong>Cliques:</strong>{" "}
												{totalClicksFiltered}
											</p>
										</div>
									)}

								{/* Cards das filiais */}
								{displayedBranches.map(
									({
										id,
										label,
										longCode,
										cityName,
										stateAbbr,
									}) => {
										const value =
											accessByBranch[longCode] || 0;
										const percentage =
											total > 0
												? (
													(value / total) *
													100
												).toFixed(2)
												: 0;

										return (
											<div
												key={id || longCode}
												style={{
													flex: "1 1 250px",
													background: "#fff",
													borderRadius: "12px",
													padding: "20px",
													boxShadow:
														"0 4px 12px rgba(0,0,0,0.1)",
													transition:
														"transform 0.2s",
												}}
												onMouseEnter={(e) =>
												(e.currentTarget.style.transform =
													"scale(1.05)")
												}
												onMouseLeave={(e) =>
												(e.currentTarget.style.transform =
													"scale(1)")
												}
												onClick={() =>
													showClicks(longCode)
												}
											>
												<div
													style={{
														display: "flex",
														alignItems: "center",
														marginBottom: "10px",
													}}
												>
													<FaBuilding
														size={20}
														color="#095077"
														style={{
															marginRight: "10px",
														}}
													/>
													<h3 style={{ margin: 0 }}>
														Filial {longCode}
													</h3>
												</div>
												<div
													style={{
														fontSize: "32px",
														fontWeight: "bold",
														color: "#333",
														marginBottom: "10px",
													}}
												>
													{value}
												</div>
												<p>
													{cityName}-{stateAbbr}
												</p>
												<div
													style={{
														height: "10px",
														background: "#eee",
														borderRadius: "5px",
													}}
												>
													<div
														style={{
															width: `${percentage}%`,
															background:
																"#095077",
															height: "100%",
															borderRadius: "5px",
															transition:
																"width 0.5s",
														}}
													></div>
												</div>
												<div
													style={{
														fontSize: "12px",
														color: "#777",
														marginTop: "5px",
													}}
												>
													{percentage}% do total
												</div>
											</div>
										);
									},
								)}
							</>
						);
					})()}
				</div>
			</div>
		</Layout>
	);
}
